import { Component, OnInit } from '@angular/core';
import { toggleAnimation } from 'src/app/shared/animations';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from '../../../shared/service/app/app.service';
import { AnalitycsService } from 'src/app/shared/service/analitycs.service';
import { CommonService } from './../../../shared/service/common/common.service';
import { AlertService } from '../../../shared/service/common/alert.service';
import moment from 'moment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Codes } from './../../../shared/constants/messages/codes';
import Swal from 'sweetalert2';
import { AuthService } from '../../../shared/service/auth/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  animations: [toggleAnimation],
})
export class CoverLoginComponent implements OnInit {
  isPhoneLogin: boolean = false;
  spanish: boolean = true;
  isDarkMode: boolean = false;
  showCodeInput: boolean = false;
  showAssistance: boolean = false;
  isModalOpen: boolean = false;
  currentImage: string = '';
  loginForm: FormGroup;
  loginPhoneForm: FormGroup;
  recoverPasswordForm: FormGroup;
  showVerificationInput: boolean = false;
  store: any;
  currYear: number = new Date().getFullYear();
  constructor(
    public translate: TranslateService,
    public storeData: Store<any>,
    public router: Router,
    private appSetting: AppService,
    private analitycs: AnalitycsService,
    private fb: FormBuilder,
    private commonService: CommonService,
    private alertService: AlertService,
    private authService: AuthService,
  ) {
    this.initStore();
    //Reactive-Form
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
    });
    this.loginPhoneForm = this.fb.group({
      phone: ['', [Validators.required, Validators.pattern(/^\+?\d{10,15}$/)]],
      code: [
        '',
        [
          Validators.required,
          Validators.pattern(/^\d{6}$/), // exactamente 6 dígitos
        ],
      ],
    });
    this.recoverPasswordForm = this.fb.group({
      emailOrPhone: ['', [Validators.required]],
      verificationCode: ['', [Validators.required, Validators.pattern(/^\d{6}$/)]],
      newPassword: ['', [Validators.required, Validators.minLength(6)]],
    });
  }
  // El método ngOnInit está implementado más abajo

  async onSubmitPhone() {
    this.analitycs.logEvent('login_form_with_phone', {
      pantalla: 'login',
      accion: 'click',
      timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
      plataforma: 'web',
    });
    if (this.loginPhoneForm.controls['phone'].invalid) {
      this.loginPhoneForm.controls['phone'].markAsTouched();
      return;
    }

    // Mostrar alerta de carga
    Swal.fire({
      title: 'Procesando...',
      text: 'Enviando código de verificación',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading(null);
      },
      showConfirmButton: false,
    });

    try {
      const phoneNumber = this.loginPhoneForm.controls['phone'].value;

      const response = await this.commonService.sendSmsCode({
        phone: {
          code: '+57',
          number: phoneNumber,
        },
      });

      // Cerrar alerta de carga
      Swal.close();

      if (response.code.code === 'PTZ0000') {
        // Mostrar el campo de código de verificación
        this.showCodeInput = true;

        // Mostrar mensaje de éxito
        Swal.fire({
          toast: true,
          icon: 'success',
          title: 'Código enviado',
          text: 'Se ha enviado un código de verificación a tu teléfono',
          position: 'top',
          timer: 3000,
          timerProgressBar: true,
          showConfirmButton: false,
        });
      } else {
        Swal.fire({
          toast: true,
          icon: 'error',
          title: 'Error',
          text: response.error || 'No se pudo enviar el código de verificación. Verifica tus datos.',
          position: 'top',
          timer: 3000,
          timerProgressBar: true,
          showConfirmButton: false,
        });
      }
    } catch (error: any) {
      // Cerrar alerta de carga
      Swal.close();

      console.error('Error al enviar el código:', error);

      // Mensaje de error más detallado
      let errorMessage = 'No se pudo conectar con el servidor, intenta nuevamente';
      let errorTitle = 'Error de conexión';

      if (error.toString && error.toString().includes('Blob')) {
        errorMessage = 'Error en el procesamiento del servidor. El equipo técnico ha sido notificado.';
        errorTitle = 'Error interno';
      } else if (error.response && error.response.status === 500) {
        errorMessage =
          'El servidor no pudo procesar la solicitud. Puede que el número de teléfono no esté registrado o el servicio esté temporalmente no disponible.';
        errorTitle = 'Error del servidor';

        // Opción para registrarse si el número no existe
        Swal.fire({
          icon: 'warning',
          title: 'Número no encontrado',
          text: 'El número de teléfono no está registrado en nuestro sistema. ¿Deseas crear una cuenta nueva?',
          showCancelButton: true,
          confirmButtonText: 'Registrarme',
          cancelButtonText: 'Cancelar',
        }).then((result) => {
          if (result.isConfirmed) {
            // Redirigir a la página de registro
            this.router.navigate(['../register']);
          }
        });
        return; // Salir de la función para evitar mostrar mensajes adicionales
      } else if (error.message) {
        errorMessage = error.message;
      }

      Swal.fire({
        toast: true,
        icon: 'error',
        title: errorTitle,
        text: errorMessage,
        position: 'top',
        timer: 5000,
        timerProgressBar: true,
        showConfirmButton: false,
      });
    }
  }

  async onSubmit() {
    this.analitycs.logEvent('login_form_with_email', {
      pantalla: 'login',
      accion: 'click',
      timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
      plataforma: 'web',
    });

    // console.log('this.loginForm.valid', this.loginForm.valid);
    if (this.loginForm.valid) {
      const userLogin = {
        email: this.loginForm.value.email,
        password: this.loginForm.value.password,
      };

      // Mostrar alerta de carga correctamente
      Swal.fire({
        title: 'Procesando...',
        text: 'Iniciando sesión',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading(null);
        },
        showConfirmButton: false,
      });

      try {
        const rspLogin = await this.commonService.login(userLogin);
        Swal.close(); // Cierra la alerta de carga una vez que se recibe la respuesta

        if (rspLogin.code.code === Codes.PTZ0000) {
          localStorage.setItem('secTkn', rspLogin.data.access_token);
          // Actualizar el estado de autenticación
          this.authService.setAuthenticated(true);
          Swal.fire({
            icon: 'success',
            toast: true,
            // imageUrl: '../../../../assets/images/icon2.png',
            // imageWidth: 100,
            // imageHeight: 100,
            title: '¡Ingreso exitoso!',
            // text: 'Bienvenido a la mejor platafoma para tu vehículo',
            position: 'top',
            // width: '20%',
            timer: 3000,
            timerProgressBar: true,
            showConfirmButton: false,
          });

          this.router.navigate(['/profile']);
        } else {
          Swal.fire({
            toast: true,
            icon: 'error',
            title: 'Error al iniciar sesión',
            text: 'Por favor, verifica tus credenciales',
            position: 'top',
            timer: 3000,
            timerProgressBar: true,
            showConfirmButton: false,
          });
          //   console.error('Error al iniciar sesión', rspLogin.code.message);
        }
      } catch (error) {
        Swal.close();
        Swal.fire({
          toast: true,
          icon: 'error',
          title: 'Error de conexión',
          text: 'No se pudo conectar con el servidor, intenta nuevamente',
          position: 'top',
        });
        console.error('Error en la petición', error);
      }
    } else {
      Swal.fire({
        toast: true,
        icon: 'warning',
        title: 'Formulario inválido',
        text: 'Por favor, completa todos los campos correctamente',
        position: 'top',
        timer: 3000,
        timerProgressBar: true,
        showConfirmButton: false,
      });
      //   console.error('Formulario inválido');
    }
  }
  async onVerifyCode() {
    const code = this.loginPhoneForm.controls['code'].value;
    const phoneNumber = this.loginPhoneForm.controls['phone'].value;

    if (!code || code.length !== 6) {
      Swal.fire({
        toast: true,
        icon: 'warning',
        title: 'Código inválido',
        text: 'Por favor ingresa un código de 6 dígitos.',
        position: 'top',
        timer: 3000,
        timerProgressBar: true,
        showConfirmButton: false,
      });
      return;
    }

    // Mostrar alerta de carga
    Swal.fire({
      title: 'Procesando...',
      text: 'Verificando código',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading(null);
      },
      showConfirmButton: false,
    });

    try {
      const response = await this.commonService.validateSmsCode({
        phone: {
          code: '+57',
          number: phoneNumber,
        },
        code: code, // 👈 el código ingresado por el usuario
      });

      // Cerrar alerta de carga
      Swal.close();

      if (response.code.code === 'PTZ0000') {
        // Guardar el token de acceso
        localStorage.setItem('secTkn', response.data.access_token);

        // Actualizar el estado de autenticación
        this.authService.setAuthenticated(true);

        Swal.fire({
          icon: 'success',
          toast: true,
          title: '¡Ingreso exitoso!',
          position: 'top',
          timer: 3000,
          timerProgressBar: true,
          showConfirmButton: false,
        });

        // Redirigir al perfil
        this.router.navigate(['/profile']);
      } else {
        Swal.fire({
          toast: true,
          icon: 'error',
          title: 'Código incorrecto',
          text: 'El código ingresado no es válido',
          position: 'top',
          timer: 3000,
          timerProgressBar: true,
          showConfirmButton: false,
        });
      }
    } catch (error: any) {
      // Cerrar alerta de carga si aún está abierta
      Swal.close();

      console.error('Error al verificar el código:', error);

      // Mensaje de error más detallado
      let errorMessage = 'No se pudo conectar con el servidor, intenta nuevamente';
      let errorTitle = 'Error de conexión';

      // Si el error contiene 'Blob' probablemente es el error específico que estamos tratando
      if (error.toString && error.toString().includes('Blob')) {
        errorMessage = 'Error en el procesamiento del servidor. El equipo técnico ha sido notificado.';
        errorTitle = 'Error interno';
      } else if (error.response && error.response.status === 500) {
        errorMessage = 'El servidor no pudo procesar la solicitud. Puede que el código ingresado sea inválido o haya expirado.';
        errorTitle = 'Error del servidor';

        // Ofrecer la opción de reenviar el código
        Swal.fire({
          icon: 'warning',
          title: 'Código inválido',
          text: 'El código ingresado no es válido o ha expirado. ¿Deseas solicitar un nuevo código?',
          showCancelButton: true,
          confirmButtonText: 'Solicitar nuevo código',
          cancelButtonText: 'Cancelar',
        }).then((result) => {
          if (result.isConfirmed) {
            // Llamar a la función para reenviar el código
            this.onSubmitPhone();
          }
        });
        return; // Salir de la función para evitar mostrar mensajes adicionales
      } else if (error.message) {
        // Si el error tiene un mensaje, mostrarlo
        errorMessage = error.message;
      }

      Swal.fire({
        toast: true,
        icon: 'error',
        title: errorTitle,
        text: errorMessage,
        position: 'top',
        timer: 5000,
        timerProgressBar: true,
        showConfirmButton: false,
      });
    }
  }

  ngOnInit() {
    // Verificar si el usuario ya tiene un token y redirigirlo al perfil
    const token = localStorage.getItem('secTkn');
    if (token) {
      console.log('El usuario ya tiene un token, redirigiendo al perfil');
      this.authService.setAuthenticated(true);

      // Mostrar mensaje de bienvenida antes de redirigir
      Swal.fire({
        icon: 'success',
        toast: true,
        title: '¡Bienvenido de nuevo!',
        text: 'Redirigiendo a tu perfil...',
        position: 'top',
        timer: 2000,
        timerProgressBar: true,
        showConfirmButton: false,
      }).then(() => {
        this.router.navigate(['/profile']);
      });
      return;
    }

    // Mostrar asistente después de un tiempo
    setTimeout(() => {
      this.showAssistance = true;
    }, 4000);

    // Configurar idioma y tema
    this.storeData
      .select((state) => state.index.locale)
      .subscribe((locale) => {
        this.spanish = locale === 'es';

        // Actualizar la imagen según el idioma
        this.currentImage = locale === 'en' ? '../../assets/images/pit2inglish.jpg' : '../../assets/images/pit2.jpg';
      });

    localStorage.setItem('light', 'dark');
    this.storeData
      .select((state) => state.index.theme)
      .subscribe((theme) => {
        this.isDarkMode = theme === 'dark';
      });

    // Registrar evento de analítica
    this.analitycs.logEvent('vista_login', {
      pantalla: 'login',
      accion: 'vista',
      timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
      plataforma: 'web',
    });
  }

  async initStore() {
    this.storeData
      .select((d) => d.index)
      .subscribe((d) => {
        this.store = d;
      });
  }
  networks() {
    this.analitycs.logEvent('redes_sociales', {
      pantalla: 'login',
      accion: 'click',
      timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
      plataforma: 'web',
    });
  }
  GoToRegister() {
    this.analitycs.logEvent('ir_a_registro', {
      pantalla: 'login',
      accion: 'click',
      timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
      plataforma: 'web',
    });

    this.router.navigate(['../register']);
  }
  forgotPassword() {
    // Reiniciar el formulario y estado
    this.recoverPasswordForm.reset();
    this.showVerificationInput = false;
  }
  goToassistant() {
    this.router.navigate(['/assistant']);
  }
  onModalClosed(event: boolean): void {
    console.log(event);
    this.isModalOpen = false;
  }

  openRegisterNumberModal(): void {
    this.isModalOpen = true;
  }

  // Método para restablecer la contraseña con el código de verificación
  async resetPassword(modal: any) {
    if (!this.recoverPasswordForm.valid) {
      Swal.fire({
        toast: true,
        icon: 'warning',
        title: 'Formulario inválido',
        text: 'Por favor, completa todos los campos correctamente',
        position: 'top',
        timer: 3000,
        timerProgressBar: true,
        showConfirmButton: false,
      });
      return;
    }

    const emailOrPhone = this.recoverPasswordForm.get('emailOrPhone')?.value || '';
    const verificationCode = this.recoverPasswordForm.get('verificationCode')?.value || '';
    const newPassword = this.recoverPasswordForm.get('newPassword')?.value || '';

    try {
      // Mostrar alerta de carga
      Swal.fire({
        title: 'Procesando...',
        text: 'Actualizando contraseña',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading(null);
        },
        showConfirmButton: false,
      });

      // Determinar si es email o teléfono
      const isEmail = emailOrPhone.includes('@');
      const requestData: any = {
        code: verificationCode,
        newPassword: newPassword,
      };

      if (isEmail) {
        requestData.email = emailOrPhone;
        requestData.phone = {
          code: '+57',
          number: '',
        };
      } else {
        requestData.email = '';
        requestData.phone = {
          code: '+57',
          number: emailOrPhone,
        };
      }

      console.log('Enviando solicitud de reseteo de contraseña:', requestData);

      // Intentar validar el código y actualizar la contraseña
      let response;

      try {
        // Verificar si el código es válido
        if (!isEmail) {
          // Para teléfono, usar el endpoint existente
          // Limpiar el número de teléfono (solo dígitos)
          const cleanPhoneNumber = emailOrPhone.replace(/\D/g, '');

          try {
            // Verificar el código usando validateSmsCode
            const validationResponse = await this.commonService.validateSmsCode({
              phone: {
                code: '+57',
                number: cleanPhoneNumber,
              },
              code: verificationCode,
            });

            if (validationResponse.code.code !== 'PTZ0000') {
              throw new Error('El código de verificación no es válido');
            }

            // Si llegamos aquí, el código es válido
            // Simular la actualización de la contraseña por ahora
            response = {
              code: { code: 'PTZ0000' },
              error: '',
            };
          } catch (phoneError: any) {
            // Si el error es 500, probablemente el número no existe o el código es inválido
            if (phoneError.response && phoneError.response.status === 500) {
              throw new Error('El código de verificación no es válido o ha expirado.');
            }
            throw phoneError; // Re-lanzar otros errores
          }
        } else {
          // Para email, verificar el código de demostración (123456)
          if (verificationCode === '123456') {
            // Código válido para la demostración
            response = {
              code: { code: 'PTZ0000' },
              error: '',
            };
          } else {
            // Código inválido
            throw new Error('El código de verificación no es válido. Para la demostración, usa 123456.');
          }
        }
      } catch (validationError: any) {
        console.error('Error al validar código:', validationError);
        if (validationError.response && validationError.response.status === 500) {
          throw new Error('El servidor no pudo validar el código. Intenta nuevamente.');
        }
        throw validationError; // Re-lanzar para que sea manejado por el catch externo
      }

      console.log('Respuesta del servidor:', response);

      // Cerrar alerta de carga
      Swal.close();

      if (response.code.code === 'PTZ0000') {
        Swal.fire({
          toast: true,
          icon: 'success',
          title: 'Contraseña actualizada',
          text: 'Tu contraseña ha sido actualizada correctamente',
          position: 'top',
          timer: 3000,
          timerProgressBar: true,
          showConfirmButton: false,
        });
        try {
          if (modal && typeof modal.close === 'function') {
            modal.close();
          }
        } catch (modalError) {
          console.error('Error al cerrar el modal:', modalError);
          // Continuar con el flujo incluso si hay un error al cerrar el modal
        }
        this.recoverPasswordForm.reset();
        this.showVerificationInput = false;
      } else {
        Swal.fire({
          toast: true,
          icon: 'error',
          title: 'Error',
          text: response.error || 'No se pudo actualizar la contraseña. Verifica el código de verificación.',
          position: 'top',
          timer: 3000,
          timerProgressBar: true,
          showConfirmButton: false,
        });
      }
    } catch (error: any) {
      // Cerrar alerta de carga si aún está abierta
      Swal.close();

      console.error('Error al resetear contraseña:', error);

      // Mostrar información detallada del error
      let errorMessage = 'No se pudo conectar con el servidor, intenta nuevamente';

      if (error.response) {
        // El servidor respondió con un código de error
        console.error('Error de respuesta:', error.response.data);
        errorMessage = `Error ${error.response.status}: ${error.response.data.message || error.response.statusText}`;
      } else if (error.request) {
        // La solicitud fue hecha pero no se recibió respuesta
        console.error('Error de solicitud:', error.request);
        errorMessage = 'No se recibió respuesta del servidor. Verifica tu conexión a internet.';
      } else {
        // Algo ocurrió al configurar la solicitud
        console.error('Error de configuración:', error.message);
        errorMessage = `Error: ${error.message}`;
      }

      Swal.fire({
        toast: true,
        icon: 'error',
        title: 'Error de conexión',
        text: errorMessage,
        position: 'top',
        timer: 5000,
        timerProgressBar: true,
        showConfirmButton: false,
      });
    }
  }
}
